import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecfa3d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ListGuide__guide"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("队伍已有")
const _hoisted_3 = { class: "ListGuide__highlight" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(", 下周一可瓜分至少")
const _hoisted_5 = { class: "ListGuide__highlight" }
const _hoisted_6 = {
  key: 1,
  class: "ListGuide__guide"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("队伍已有")
const _hoisted_8 = { class: "ListGuide__highlight" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ，快加入一起赚KK币吧")

import TeamMember from '@/components/TeamMember.vue';
import { useStore } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const teamMaxPerson = computed(() => store.state.rule.teamMaxPerson);
const teamMinObtain = computed(() => store.state.teamMinObtain);

const isJoin = computed(() => {
  if (store.state.isShare) {
    return store.state.joinedTeam;
  } else {
    return true;
  }
});

const memberList = computed(() => {
  return store.state.currentMembers.map(member => ({
    isJoin: isJoin.value,
    invitation: member.invitation,
    obtained: member.obtainCount,
    clockDay: member.clockOnDays,
    userName: member.userName,
    avatar: member.avatar,
    id: member.userId,
    clockOn: Boolean(member.clockOn),
    myInvite: member.myInvite
  }));
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isJoin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(memberList).length) + "/" + _toDisplayString(_unref(teamMaxPerson)) + "人", 1),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(teamMinObtain)) + "KK币", 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(memberList).length) + "/" + _toDisplayString(_unref(teamMaxPerson)) + "人", 1),
          _hoisted_9
        ])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberList), (member) => {
      return (_openBlock(), _createBlock(TeamMember, {
        options: member,
        key: member.id
      }, null, 8, ["options"]))
    }), 128))
  ], 64))
}
}

})